import { render, staticRenderFns } from "./BAHome.vue?vue&type=template&id=3bb20880&"
import script from "./BAHome.vue?vue&type=script&lang=js&"
export * from "./BAHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports